import {
  leadsBulkDeleteCreateMutation,
  leadsListQueryKey,
  leadsPipelineListQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import {
  useInvalidatePredicateQueries,
  useResetPagination
} from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, ModalProps } from 'antd'

type Props = {
  leads?: number[]
  onClose: () => void
  onSubmit: () => void
} & ModalProps

export const DeleteLeads = ({ leads, onClose, onSubmit, ...props }: Props) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()
  const { resetPagination } = useResetPagination()

  const { notification } = App.useApp()

  const { mutate, isPending } = useMutation({
    ...leadsBulkDeleteCreateMutation(),
    onSuccess: (res) => {
      invalidateQueries([leadsListQueryKey(), leadsPipelineListQueryKey()])
      resetPagination()
      notification.success({
        message: t('success.success'),
        description: res.message
      })

      onSubmit()
    },
    onError: (error) => showApiErrors(error)
  })

  const onSuccess = () => mutate({ body: { leads } })

  return (
    <ConfirmModal
      {...props}
      children={t('confirm.delete_items_confirmation', {
        items: leads?.length
      })}
      loading={isPending}
      onSuccess={onSuccess}
      onCancel={onClose}
    />
  )
}
